import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const JobTypeVisual = ({ type }) => (
  <StaticQuery
    query={graphql`
      query {
        type0: file(relativePath: { eq: "jobs/job-type/0.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        type1: file(relativePath: { eq: "jobs/job-type/1.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        type2: file(relativePath: { eq: "jobs/job-type/2.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        type3: file(relativePath: { eq: "jobs/job-type/3.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        type4: file(relativePath: { eq: "jobs/job-type/4.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        type5: file(relativePath: { eq: "jobs/job-type/5.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        type6: file(relativePath: { eq: "jobs/job-type/6.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        type7: file(relativePath: { eq: "jobs/job-type/7.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        type8: file(relativePath: { eq: "jobs/job-type/8.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        type9: file(relativePath: { eq: "jobs/job-type/9.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        type10: file(relativePath: { eq: "jobs/job-type/10.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        type11: file(relativePath: { eq: "jobs/job-type/11.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        type12: file(relativePath: { eq: "jobs/job-type/12.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        type13: file(relativePath: { eq: "jobs/job-type/13.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        type14: file(relativePath: { eq: "jobs/job-type/14.png" }) {
          childImageSharp {
            fluid(maxWidth: 246, maxHeight: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={(data) => {
      let visualIndex = 'type0';
      if (data['type' + type]) visualIndex = 'type' + type;
      return <Img fluid={data[visualIndex].childImageSharp.fluid} />;
    }}
  />
);

export default JobTypeVisual;
